import {
  HYDRATABLE_SLICES,
  SNAPSHOT_SCHEMA_VERSION
} from 'data/error-log-constants';
import { ReduxSnapshotType } from 'types/error-log';

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isCompatibleReduxSnapshot(
  snapshot: unknown
): snapshot is ReduxSnapshotType {
  if (!isPlainObject(snapshot)) {
    return false;
  }
  const { meta } = snapshot;
  if (!isPlainObject(meta) || meta.schemaVersion !== SNAPSHOT_SCHEMA_VERSION) {
    return false;
  }
  if (!isPlainObject(snapshot.slices)) {
    return false;
  }
  const { slices } = snapshot;
  return HYDRATABLE_SLICES.every((key) => {
    if (!(key in slices)) {
      return true;
    }
    return isPlainObject(slices[key]);
  });
}
